(() => {
  'use strict';
  const records = new WeakMap();
  let sequence = 0;
  function message(field) {
    const v = field.validity;
    if (v.valueMissing) {
      if (field.type === 'email') return 'Please enter your email address.';
      if (field.type === 'tel') return 'Please enter your phone number.';
      if (field.type === 'checkbox') return 'Please select this checkbox to continue.';
      if (field.type === 'file') return 'Please choose a file.';
      if (field.tagName === 'SELECT' || field.type === 'radio') return 'Please choose an option.';
      return 'Please complete this field.';
    }
    if (v.typeMismatch && field.type === 'email') return 'Please enter a valid email address.';
    if (v.typeMismatch && field.type === 'url') return 'Please enter a valid website address.';
    if (v.tooShort) return `Please enter at least ${field.minLength} characters.`;
    if (v.tooLong) return `Please enter no more than ${field.maxLength} characters.`;
    if (v.rangeUnderflow) return `Please enter a value of ${field.min} or more.`;
    if (v.rangeOverflow) return `Please enter a value of ${field.max} or less.`;
    if (v.badInput || v.stepMismatch) return 'Please enter a valid number.';
    if (v.customError && !/[\u4e00-\u9fff]/.test(field.validationMessage)) return field.validationMessage;
    return 'Please check this field and try again.';
  }
  function clear(field) {
    const item = records.get(field);
    if (!item) return;
    if (item.shared) { item.error.textContent = ''; delete item.error.dataset.state; }
    else item.error.remove();
    if (item.invalid === null) field.removeAttribute('aria-invalid');
    else field.setAttribute('aria-invalid', item.invalid);
    if (item.description === null) field.removeAttribute('aria-describedby');
    else field.setAttribute('aria-describedby', item.description);
    records.delete(field);
  }
  document.addEventListener('invalid', event => {
    const field = event.target;
    if (!(field instanceof HTMLElement) || !field.validity) return;
    // Keep constraint validation's false result, but replace browser-localized bubbles.
    event.preventDefault();
    let item = records.get(field);
    if (!item) {
      const shared = field.id === 'island-letter-email' && document.getElementById('island-letter-status');
      const error = shared || document.createElement('span');
      if (!shared) {
        error.id = `yizcho-field-error-${++sequence}`;
        error.className = 'yizcho-field-error';
        error.setAttribute('role', 'alert');
        error.style.cssText = 'display:block;grid-column:1/-1;flex-basis:100%;margin:6px 0;color:#8b351f;font:400 13px/1.45 system-ui,sans-serif;white-space:normal';
        field.insertAdjacentElement('afterend', error);
      }
      item = { error, shared: !!shared, invalid: field.getAttribute('aria-invalid'), description: field.getAttribute('aria-describedby') };
      records.set(field, item);
      field.setAttribute('aria-describedby', [item.description, error.id].filter(Boolean).join(' '));
    }
    field.setAttribute('aria-invalid', 'true');
    item.error.textContent = message(field);
    if (item.shared) item.error.dataset.state = 'error';
    const invalid = field.form?.querySelector(':invalid');
    if (!invalid || invalid === field) field.focus({ preventScroll: true });
  }, true);
  document.addEventListener('input', event => clear(event.target), true);
  document.addEventListener('change', event => clear(event.target), true);
  document.addEventListener('reset', event => { for (const field of event.target.elements || []) clear(field); }, true);
})();
